"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CianMortgageBank = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./CianMortgageBank.css"));
var _uiKit = require("@cian/ui-kit");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CianMortgageBank = props => {
  const {
    bank,
    mortgagePartnerLink,
    promoType,
    onMortgageClick
  } = props;
  if (!bank || !bank.isPartner || promoType === 'maternalCapital') {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: style['container']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading4, null, "\u0411\u0430\u043D\u043A"), /*#__PURE__*/React.createElement("div", {
    className: style['bank']
  }, /*#__PURE__*/React.createElement(_uiKit.Avatar, {
    type: "bank",
    src: bank.logoUrl,
    size: 40,
    hideBorder: true
  }), /*#__PURE__*/React.createElement(_uiKit.UIText1, null, bank.name), mortgagePartnerLink && /*#__PURE__*/React.createElement("div", {
    className: style['link']
  }, /*#__PURE__*/React.createElement(_uiKit.Link, {
    href: mortgagePartnerLink,
    onClick: onMortgageClick,
    fontSize: "S"
  }, "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0438\u043F\u043E\u0442\u0435\u043A\u0443 \u043E\u043D\u043B\u0430\u0439\u043D"))));
};
exports.CianMortgageBank = CianMortgageBank;